import DateRangePicker from './DateRangePicker.view';

export default DateRangePicker;
